import { render, staticRenderFns } from "./chat-message.vue?vue&type=template&id=e53e0800&scoped=true&"
import script from "./chat-message.vue?vue&type=script&lang=js&"
export * from "./chat-message.vue?vue&type=script&lang=js&"
import style0 from "./chat-message.vue?vue&type=style&index=0&id=e53e0800&prod&lang=css&"
import style1 from "./chat-message.vue?vue&type=style&index=1&id=e53e0800&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53e0800",
  null
  
)

export default component.exports